import { render, staticRenderFns } from "./GenericTable.vue?vue&type=template&id=4ba2309a"
import script from "./GenericTable.vue?vue&type=script&lang=js"
export * from "./GenericTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports